import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import isNotNil from "ramda-extension/es/isNotNil";
import React from 'react';
import CSSTransition from 'react-transition-group/CSSTransition';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import { useDefaultComponentValue } from '../../../utils/useDefaultComponentValue';
const COMPONENT_NAME = 'ComponentLoader';
const ComponentLoader = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { noPreloader = false, isLoading = false, hasError = false, loaded = false, large = false, className, renderIfError, renderOnlyIfLoaded = false, children, noError = false, errorElementType: Error, ...errorProps } = props;
    let resolvedClassName = null;
    if (!noPreloader) {
        resolvedClassName = isLoading && !hasError && !loaded ? cx([
            'Preloader',
            {
                'Preloader--sizeLarge': large
            },
            className
        ]) : className;
    }
    const showChild = !(renderOnlyIfLoaded && !loaded) && (!hasError || renderIfError);
    const showError = !noError && hasError && isNotNil(Error);
    return /*#__PURE__*/ React.createElement("div", {
        className: resolvedClassName
    }, /*#__PURE__*/ React.createElement(TransitionGroup, null, /*#__PURE__*/ React.createElement(CSSTransition, {
        className: "transition",
        timeout: {
            enter: 500,
            exit: 300
        }
    }, /*#__PURE__*/ React.createElement("div", null, showError ? /*#__PURE__*/ React.createElement(Error, errorProps) : null, showChild && children))));
};
ComponentLoader.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    errorElementType: PropTypes.elementType,
    hasError: PropTypes.bool,
    isLoading: PropTypes.bool,
    large: PropTypes.bool,
    loaded: PropTypes.bool,
    noError: PropTypes.bool,
    noPreloader: PropTypes.bool,
    renderIfError: PropTypes.bool,
    renderOnlyIfLoaded: PropTypes.bool
};
export default ComponentLoader;
